import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail, Phone, MapPin } from 'lucide-react';
import './Footer.css';

const WHATSAPP = process.env.REACT_APP_WHATSAPP || '919395419651';
const INSTAGRAM = process.env.REACT_APP_INSTAGRAM || 'https://www.instagram.com/skyleaftravelss';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-grid">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">
            <span className="footer-logo-badge">
              <img src="/images/logo.jpg" alt="Skyleaf Travels" width="56" height="56" />
            </span>
          </Link>
          <p>
            Exploring the hidden wonders of Northeast India — waterfalls, road trips, and offbeat escapes.
            Private &amp; group tours, planned by a team that's actually been there.
          </p>
          <div className="footer-socials">
            <a href={INSTAGRAM} target="_blank" rel="noreferrer" aria-label="Instagram"><Instagram size={18} /></a>
          </div>
        </div>

        <div className="footer-col">
          <h4>Destinations</h4>
          <ul>
            <li><Link to="/destinations">All Destinations</Link></li>
            <li><Link to="/destinations/meghalaya">Meghalaya</Link></li>
            <li><Link to="/destinations/kaziranga-and-assam">Assam</Link></li>
            <li><Link to="/destinations/arunachal-pradesh">Arunachal Pradesh</Link></li>
            <li><Link to="/destinations/sikkim">Sikkim</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Plan Your Trip</h4>
          <ul>
            <li><Link to="/packages">Packages</Link></li>
            <li><Link to="/guides">State Guides</Link></li>
            <li><Link to="/guides-blog">Travel Guides</Link></li>
            <li><Link to="/travel-tips">Permits & Best Time</Link></li>
            <li><Link to="/faq">FAQ</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Company</h4>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><a href={`https://wa.me/${WHATSAPP}`} target="_blank" rel="noreferrer">WhatsApp Us</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Get in Touch</h4>
          <ul className="footer-contact">
            <li><MapPin size={16} /> Guwahati, Assam, India</li>
            <li><Phone size={16} /> <a href="tel:+919395419651">+91 93954 19651</a></li>
            <li><Phone size={16} /> <a href="tel:+919707353985">+91 97073 53985</a></li>
            <li><Mail size={16} /> hello@skyleaftravels.com</li>
          </ul>
        </div>
      </div>

      <div className="container footer-bottom">
        <p>© {new Date().getFullYear()} Skyleaf Travels. All rights reserved.</p>
        <div className="footer-legal-links">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-conditions">Terms &amp; Conditions</Link>
          <Link to="/cancellation-policy">Cancellation Policy</Link>
        </div>
      </div>
    </footer>
  );
}
